<template>
  <div class="work-wrap">
    <div class="work-top-box">
      <div @click="backHandle">返回</div>
      <div @click="historyHandle" style="color: #2f70ff">历史记录</div>
    </div>

    <div class="work-center-box">
      <div class="mt-10" style="overflow-y: auto; height: calc(100% - 70px)">
        <div class="work-card-box">
          <div class="work-title">
            <div class="title cell" style="font-weight: bold">故障上报</div>
          </div>
          <el-form :model="form" ref="form" class="mt-10" style="background-color: #f9fafd; padding: 0 10px 10px 10px">
            <!-- <el-form-item prop="address" label="安装位置" :rules="{required: false,message: '请选择安装位置', trigger: 'change'}">
              <el-cascader style="width:100%" popper-class="address-cascader-popper" placeholder="请选择安装位置" :props="defaultProps" v-model="form.address" :options="spaceList" filterable @change="spaceChange" clearable></el-cascader>
            </el-form-item> -->
            <!-- <el-form-item prop="organId" label="项目名称" :rules="{ required: true, message: '请选择项目名称', trigger: 'change' }">
              <el-select v-model="form.organId" placeholder="请选择项目名称" clearable style="width: 100%" @change="organChange">
                <el-option v-for="(item, i) in organIdList" :key="i" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="faultTypeCode" label="故障类型" :rules="{ required: true, message: '请选择故障类型', trigger: 'change' }">
              <el-select v-model="form.faultTypeCode" placeholder="请选择故障类型" clearable style="width: 100%">
                <el-option v-for="(item, i) in typeList" :key="i" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item> -->
            <div class="mb-5 pt-10">安装位置</div>

            <el-form-item prop="courtyardId" label="院落" :rules="{ required: true, message: '请选择院落', trigger: 'change' }">
              <el-select v-model="form.courtyardId" popper-class="address-cascader-popper" placeholder="请选择院落" clearable style="width: 100%" @change="courtyardChange">
                <el-option v-for="(item, i) in courtyardIdList" :key="i" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="floorId" label="楼宇" :rules="{ required: false, message: '请选择楼宇', trigger: 'change' }">
              <el-select v-model="form.floorId" popper-class="address-cascader-popper" placeholder="请选择楼宇" clearable style="width: 100%" @change="floorChange">
                <el-option v-for="(item, i) in floorIdList" :key="i" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="storeysId" label="楼层" :rules="{ required: false, message: '请选择楼层', trigger: 'change' }">
              <el-select v-model="form.storeysId" popper-class="address-cascader-popper" placeholder="请选择楼层" clearable style="width: 100%" @change="storeysChange">
                <el-option v-for="(item, i) in storeysIdList" :key="i" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="roomId" label="房间号" :rules="{ required: false, message: '请选择房间号', trigger: 'change' }">
              <el-select v-model="form.roomId" popper-class="address-cascader-popper" placeholder="请选择房间号" clearable style="width: 100%" @change="roomChange">
                <el-option v-for="(item, i) in roomIdList" :key="i" :label="item.roomNo" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="deviceIdList" label="设备名称" :rules="{ required: false, message: '请选择设备名称', trigger: 'change' }">
              <el-select v-model="form.deviceIdList" popper-class="address-cascader-popper" placeholder="请选择设备名称" clearable style="width: 100%" multiple>
                <el-option v-for="(item, i) in equipNoList" :key="i" :label="`${item.deviceName}（${item.deviceNo}）`" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item prop="iotProductId" label="设备厂家" :rules="{ required: false, message: '请选择设备厂家', trigger: 'change' }">
              <el-select v-model="form.iotProductId" placeholder="请选择设备厂家" clearable style="width: 100%" filterable>
                <el-option v-for="(item, i) in iotProductIdList" :key="i" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item> -->

            <!-- <el-form-item prop="productTypeId" label="设备类型" :rules="{ required: true, message: '请选择设备类型', trigger: 'change' }">
              <el-select v-model="form.productTypeId" placeholder="请选择设备类型" clearable style="width: 100%" filterable>
                <el-option v-for="(item, i) in productTypeIdList" :key="i" :label="item.title" :value="item.id"></el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item prop="imageList" label="故障图片" :rules="{ required: true, message: '请选择故障图片', trigger: 'change' }">
              <div style="display: flex; flex-wrap: wrap; width: 100%" class="mt-5" v-if="!browser">
                <div v-for="(img, index) in form.imageList" :key="index" style="position: relative">
                  <el-image style="width: 120px; height: 120px" class="mr-5" :src="img" :preview-src-list="form.imageList"></el-image>
                  <div class="img-remove-color">
                    <i @click="removeImage(index)" class="el-icon-delete"></i>
                  </div>
                </div>
                <div v-if="form.imageList.length < 5">
                  <el-button @click="chooseImage" icon="el-icon-plus" style="width: 120px; height: 120px; font-size: 22px"></el-button>
                </div>
              </div>
              <!-- 单点登录时在浏览器打开的页面用下面的图片上传，不用微信jssdk方式 -->
              <div style="display: flex; flex-wrap: wrap; width: 100%" class="mt-5" v-else>
                <img-upload :fileSize="20" :limit="5" v-model="form.imageList"></img-upload>
                <!-- <input type="file" accept="image/*" capture="user">
                <input type="file" accept="image/*" capture="camera" style="margin-top:20px"> -->

                <!-- <input type="file" accept="image/*" capture="camera"> -->
              </div>
            </el-form-item>
            <el-form-item prop="remark" label="故障备注" :rules="{ required: true, message: '请输入故障备注', trigger: 'change' }" style="position: relative">
              <el-input type="textarea" v-model="form.remark" maxlength="150" rows="5" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="请输入故障备注"></el-input>
              <span style="position: absolute; right: 0; font-size: 12px; bottom: -25px; color: #909399">{{ form.remark.length }}/150</span>
            </el-form-item>
          </el-form>
        </div>

        <div class="detail-deal-btn mt-10" @click="submitHandle">提交故障</div>
      </div>
    </div>

    <!-- 单点登录时跳转按钮 -->
    <div v-show="browser" class="browser-btn-wrap" @click="browserBtnClick">
      <div>故障工单</div>
    </div>

    <!-- 单点登录时上传图片选择图库获取拍照 -->
    <div v-show="browser">
      <div></div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { initWeChatSDK } from '@/utils/wechat';
import imgUpload from '@/globalComponent/ImgUpload/index.vue';
export default {
  components: {
    imgUpload,
  },
  data() {
    return {
      browser: sessionStorage.getItem('browser'),
      form: {
        address: [],
        deviceIdList: [],
        imageList: [],
        remark: '',
        courtyardId: '',
        floorId: '',
        storeysId: '',
        roomId: '',
        // organId: '',
        // faultTypeCode: '',
        // iotProductId: '',
        // productTypeId: '',
      },
      // typeList: [],
      // productTypeIdList: [],
      // iotProductIdList: [],
      // organIdList: [],
      courtyardIdList: [],
      floorIdList: [],
      storeysIdList: [],
      roomIdList: [],
      equipNoList: [],
      spaceList: [],
      defaultProps: {
        checkStrictly: true,
        label: 'title',
        value: 'id',
      },
      faultImages: [],
      serverIds: [],
      wxReady: false, // 微信SDK是否已准备就绪
      userInfo: {},
    };
  },
  mounted() {
    this.initWeChatSDK();
  },
  activated() {
    this.browser = sessionStorage.getItem('browser');
    this.form = {
      address: [],
      deviceIdList: [],
      imageList: [],
      remark: '',
      courtyardId: '',
      floorId: '',
      storeysId: '',
      roomId: '',
      // organId: '',
      // faultTypeCode: '',
      // iotProductId: '',
      // productTypeId: '',
    };
    this.userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
    // this.typeList = [];
    // this.productTypeIdList = [];
    // this.iotProductIdList = [];
    // this.organIdList = [];
    this.courtyardIdList = [];
    this.floorIdList = [];
    this.storeysIdList = [];
    this.roomIdList = [];
    this.equipNoList = [];
    this.serverIds = [];
    this.getSelectData();
    // this.getSpaceData();
    // this.getOrganData();
    this.initWeChatSDK();
  },
  methods: {
    // 初始化微信SDK配置
    async initWeChatSDK() {
      this.wxReady = false;
      try {
        await initWeChatSDK(this.$http, this.$API, ['chooseImage', 'uploadImage', 'getLocalImgData']);
        this.wxReady = true;
      } catch (error) {
        this.wxReady = false;
        console.error('微信SDK初始化失败', error);
      }
    },
    backHandle() {
      // this.$router.push({ path: '/home' });
      let url = '/home';
      window.location.assign(url);
    },
    historyHandle() {
      // this.$router.push({ path: '/fault/report/history' });
      let url = '/fault/report/history';
      window.location.assign(url);
    },
    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            deviceIdList: this.form.deviceIdList,
            faultDescription: this.form.remark,
            mediaList: this.serverIds,
            courtyardId: this.form.courtyardId || '',
            floorId: this.form.floorId || '',
            storeysId: this.form.storeysId || '',
            roomId: this.form.roomId || '',
            // fileRequestList: this.form.imageList,
            // organId: this.form.organId || '',
            // faultTypeCode: this.form.faultTypeCode || '',
            // iotProductId: this.form.iotProductId || '',
            // productTypeId: this.form.productTypeId || '',

            // courtyardId: this.form.address[0] || '',
            // floorId: this.form.address[1] || '',
            // storeysId: this.form.address[2] || '',
            // roomId: this.form.address[3] || '',
          };
          console.log('params', params);
          this.$http.post(this.$API.repair_apply_add, params).then((res) => {
            if (res.success) {
              this.$message.success(res.msg);
              // this.$router.push({ path: '/home' });
              let url = '/home';
              window.location.assign(url);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    async chooseImage() {
      // 检查微信SDK是否已就绪，如果未就绪则等待或重新初始化
      if (!this.wxReady) {
        // 如果SDK未就绪，尝试重新初始化并等待
        await this.initWeChatSDK();
        // 等待一下让wx.ready有机会执行
        await new Promise((resolve) => setTimeout(resolve, 500));
      }

      wx.chooseImage({
        count: 5 - this.form.imageList.length,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: (res) => {
          let localId = res.localIds;
          // if (localId.length) {
          //   localId.forEach(item => {
          //     this.form.imageList.push(item);
          //   })
          // }

          /**
           * 获取所有上传的图片的serverId
           */
          let _this = this;
          let i = 0;
          function uploadNext() {
            if (i < localId.length) {
              wx.uploadImage({
                localId: localId[i],
                isShowProgressTips: 1,
                success: function (res) {
                  _this.serverIds.push(res.serverId);
                  i++;
                  uploadNext();
                },
              });

              wx.getLocalImgData({
                localId: localId[i],
                success: function (res) {
                  let localData = res.localData;
                  // 判断是否包含头部信息
                  if (localData.indexOf('data:image') !== 0) {
                    localData = 'data:image/jpeg;base64,' + localData;
                  }
                  // 替换换行符
                  localData = localData.replace(/\r|\n/g, '');
                  // 如果是 iOS WKWebView，可能需要替换图片类型
                  if (window.__wxjs_is_wkwebview) {
                    localData = localData.replace('data:image/jgp', 'data:image/jpeg');
                  }
                  _this.form.imageList.push(localData);
                },
              });
            }
          }
          uploadNext();
        },
      });
    },

    removeImage(i) {
      this.form.imageList.splice(i, 1);
      // 移除对应的serverId防止提交时删除的被上传
      this.serverIds.splice(i, 1);
    },
    organChange() {
      this.form.courtyardId = [];
      let params = {
        organId: this.form.organId,
      };
      this.$http.get(this.$API.courtyard_listAll, { params }).then((res) => {
        this.courtyardIdList = res.data || [];
      });
    },
    getSelectData() {
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      });
      this.$http.get(this.$API.courtyard_listAll).then((res) => {
        this.courtyardIdList = res.data || [];
      });
    },
    spaceChange() {
      this.equipNoList = [];
      this.form.deviceIdList = [];
      if (this.form.courtyardId) {
        let params = {
          courtyardId: this.form.courtyardId || '',
          floorId: this.form.floorId || '',
          storeysId: this.form.storeysId || '',
          roomId: this.form.roomId || '',
          // courtyardId: this.form.address[0] || '',
          // floorId: this.form.address[1] || '',
          // storeysId: this.form.address[2] || '',
          // roomId: this.form.address[3] || '',
        };
        this.$http.get(this.$API.meter_space_device_list, { params }).then((res) => {
          this.equipNoList = res.data || [];
        });
      }
    },
    courtyardChange() {
      this.form.floorId = '';
      this.form.storeysId = '';
      this.form.roomId = '';
      this.floorIdList = [];
      this.storeysIdList = [];
      this.roomIdList = [];
      this.spaceChange();

      let params = {
        courtyardId: this.form.courtyardId,
      };
      this.$http.get(this.$API.floor_list, { params }).then((res) => {
        this.floorIdList = res.data || [];
      });
    },
    floorChange() {
      this.form.storeysId = '';
      this.form.roomId = '';
      this.storeysIdList = [];
      this.roomIdList = [];
      this.spaceChange();
      let params = {
        floorId: this.form.floorId,
      };
      this.$http.get(this.$API.storeys_list, { params }).then((res) => {
        this.storeysIdList = res.data || [];
      });
    },
    storeysChange() {
      this.form.roomId = '';
      this.roomIdList = [];
      this.spaceChange();
      let params = {
        storeysId: this.form.storeysId,
      };
      this.$http.get(this.$API.room_list, { params }).then((res) => {
        this.roomIdList = res.data || [];
      });
    },
    roomChange() {
      this.spaceChange();
    },
    browserBtnClick() {
      this.$router.push('/fault/work');
    },
    getOrganData() {
      let params = {
        managerOrganId: this.userInfo.currentOrgId,
      };
      this.$http.get(this.$API.sysOrganTreeRelation_treeByManagerOrgan, { params }).then(async (res) => {
        if (res.data && res.data.children && res.data.children.length) {
          this.organIdList = res.data.children;
        } else {
          this.organIdList = [{ name: this.userInfo.currentOrgName, id: this.userInfo.currentOrgId }];
        }
      });
    },
    getSpaceData() {
      let params = {
        organId: this.userInfo.currentOrgId,
      };
      this.$http.get(this.$API.repair_order_dropdown_options, { params }).then((res) => {
        this.typeList = res.data.faultTypes || [];
        this.iotProductIdList = res.data.iotProducts || [];
      });
      this.$http.get(this.$API.device_product_tree).then((res) => {
        const treeData = res.data || [];
        const leafList = [];
        const collectLeaf = (nodes) => {
          (nodes || []).forEach((node) => {
            if (node.children && node.children.length) {
              collectLeaf(node.children);
            } else {
              leafList.push(node);
            }
          });
        };
        collectLeaf(treeData);
        this.productTypeIdList = leafList;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.work-wrap {
  height: 100%;
}
.work-top-box {
  display: flex;
  height: 50px;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  font-size: 1.6rem;
  padding: 0 10px;
}
.work-center-box {
  padding: 0 10px;
  height: 100%;
}
.work-card-box {
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  .work-title {
    display: flex;
    .work-status {
      flex: 1 0 100px;
      text-align: right;
      font-size: 1.6rem;
    }
    .title {
      font-size: 1.6rem;
    }
  }
  .work-content-box {
    padding: 10px;
    font-size: 1.6rem;
    border-radius: 6px;
    background-color: #f9fafd;
  }
}
.detail-deal-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 40px;
  color: #fff;
  background-color: #2f70ff;
  text-align: center;
}
.img-remove-color {
  position: absolute;
  font-size: 22px;
  width: 22px;
  height: 22px;
  right: 10px;
  bottom: 25px;
  .el-icon-delete {
    color: #fff;
  }
}

.browser-btn-wrap {
  position: fixed;
  bottom: 40px;
  right: 10px;
  background-color: #ecf5ff;
  padding: 10px 5px;
  border-radius: 8px 0 0 8px;
  writing-mode: vertical-rl;
  text-orientation: upright;
  cursor: pointer;
}
</style>

<style lang="scss">
.address-cascader-popper {
  width: calc(100% - 60px);
  overflow-x: auto;
  .el-scrollbar {
    .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }
}
</style>
